module.exports = "/assets/756d3562f9ce1ba5958a99a797487522.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-details-flight/assets/icon-take-off.png
// module id = 935
// module chunks = 0